import { c as _c } from "react/compiler-runtime";
import { PricePlanLimitedSubscriptionInterface, PricePlanSubscriptionInterface } from '@systemeio/types';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface SubscriptionDescriptionProps {
  subscriptionPricePlan: PricePlanSubscriptionInterface | PricePlanLimitedSubscriptionInterface;
  amountWithCurrency: string;
  quantity: number;
  coupon: {
    innerName: string;
  } | null;
}
function SubscriptionDescription(t0) {
  const $ = _c(28);
  const {
    amountWithCurrency,
    subscriptionPricePlan,
    quantity,
    coupon
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.common.price_plan.subscription_plan.interval_label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `dashboard.funnel.configuration.common.price_plan.period.${subscriptionPricePlan.recurringOptions.interval}`;
  let t3;
  if ($[2] !== subscriptionPricePlan.recurringOptions.intervalCount || $[3] !== t || $[4] !== t2) {
    t3 = t(t2, {
      count: subscriptionPricePlan.recurringOptions.intervalCount
    });
    $[2] = subscriptionPricePlan.recurringOptions.intervalCount;
    $[3] = t;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${amountWithCurrency} ${t1} ${t3}`;
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="truncate">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== subscriptionPricePlan.recurringOptions.limitOfPayments || $[9] !== t) {
    t6 = subscriptionPricePlan.recurringOptions.limitOfPayments && <div className="truncate">{`${t("dashboard.funnel.configuration.common.price_plan.subscription_plan.limit_of_payments")} : ${subscriptionPricePlan.recurringOptions.limitOfPayments}`}</div>;
    $[8] = subscriptionPricePlan.recurringOptions.limitOfPayments;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== subscriptionPricePlan.recurringOptions.trialInterval || $[12] !== subscriptionPricePlan.recurringOptions.trialPeriod || $[13] !== t) {
    t7 = subscriptionPricePlan.recurringOptions.trialPeriod > 0 && subscriptionPricePlan.recurringOptions.trialInterval && <div className="truncate">{`${t("dashboard.funnel.configuration.common.price_plan.subscription_plan.trial_period")} : ${t(`dashboard.funnel.configuration.common.price_plan.period.${subscriptionPricePlan.recurringOptions.trialInterval}`, {
        count: subscriptionPricePlan.recurringOptions.trialPeriod
      })}`}</div>;
    $[11] = subscriptionPricePlan.recurringOptions.trialInterval;
    $[12] = subscriptionPricePlan.recurringOptions.trialPeriod;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== quantity || $[16] !== subscriptionPricePlan.innerName || $[17] !== t) {
    t8 = quantity > 1 ? <div className="truncate">{`${t("dashboard.funnel.configuration.common.for_label")} ${quantity} x ${subscriptionPricePlan.innerName}`}</div> : <div className="truncate">{subscriptionPricePlan.innerName}</div>;
    $[15] = quantity;
    $[16] = subscriptionPricePlan.innerName;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== coupon || $[20] !== t) {
    t9 = coupon && <div className="truncate">{`${t("dashboard.funnel.configuration.common.with_the_coupon_label")} `}<span className="font-bold">{coupon.innerName}</span></div>;
    $[19] = coupon;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t5}{t6}{t7}{t8}{t9}</div>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
export default SubscriptionDescription;